module.exports = __webpack_public_path__ + "img/noFilledBookmard.ad515ae5.svg";